import { Component, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { CustomValidator } from "../_services/customValidator";
import { LoginService } from "../_services/login.service";
import { ActivatedRoute, Router } from "@angular/router";
import { GlobalService } from "../_services/global.service";

@Component({
    selector: 'app-self-signup',
    templateUrl: './self-signup.component.html',
    styleUrls: ['./self-signup.component.scss'],
    standalone: false
})

export class SelfSignupComponent implements OnInit {

    successMessage: string = '';
    errorMessage: string = '';
    signupform: UntypedFormGroup;
    showpassword: boolean = false

    show: boolean = false;
    showConfirm: boolean = false;
    termsacceptError: boolean = false;
    confirmemailform: boolean = false
    disableEmailInput: boolean = false;
    companyName: string[] = [];

    admin_emailid: any;
    admin_name: any;
    expiry_time: any;
    user_emailid: any;
    user_already_exist: any;

    constructor(public fb: UntypedFormBuilder, private loginService: LoginService, private router: Router, private route: ActivatedRoute) { }


    ngOnInit(): void {

        // this.getDropdown(null, null);

        this.route.queryParams.subscribe((params: any) => {
            this.admin_emailid = GlobalService.decryptData(params['tokense']);
            this.user_emailid = GlobalService.decryptData(params['tokenue']);
            this.admin_name = GlobalService.decryptData(params['tokenun']);
            this.expiry_time = GlobalService.decryptData(params['tokenv']);
            this.user_already_exist = GlobalService.decryptData(params['tokenau']);
        });


        if(this.user_emailid) {
            this.disableEmailInput = true;
        } else {
            this.disableEmailInput = false;
        }

        this.signupform = this.fb.group({
            firstName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z]*$/i)])],
            lastName: ['', Validators.compose([Validators.required, noWhitespaceValidator, Validators.pattern(/^[a-zA-Z]*$/i)])],
            loginemail: [this.user_emailid ? this.user_emailid : '', Validators.compose([Validators.required, Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$'), Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
            designation: ['', Validators.compose([noWhitespaceValidator, Validators.pattern(/^[a-zA-Z\s.-]*$/i)])],
            password: [null, Validators.compose([
                // 1. Password Field is Required
                Validators.required,
                // 2. check whether the entered password has a number
                CustomValidator.patternValidator(/\d/, { hasNumber: true }),
                // 3. check whether the entered password has upper case letter
                CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
                // 4. check whether the entered password has a lower-case letter
                CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
                // 5. check whether the entered password has a special character
                CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
                // 6. Has a minimum length of 8 characters
                Validators.minLength(8),
                // 7. check whether the entered password has a reserved keyword
                CustomValidator.keywordIncludes("password", { hasKeyword: true })])],
            confirmpassword: ['', Validators.required],
            companyname: ['', Validators.compose([noWhitespaceValidator, Validators.pattern(/^[a-zA-Z\s.'-]*$/i)])],
            termsaccept: [false, Validators.requiredTrue],
        })

        function noWhitespaceValidator(control: AbstractControl) {
            const isWhitespace = (control.value || '').trim().length === 0;
            const isValid = !isWhitespace;
            return isValid ? null : { 'required': true };
        }

        this.signupform.valueChanges.subscribe((data) => {
            if(!data.companyname.trim()) {
                this.companyName = [];
            };

            if (data.password != data.confirmpassword) {
                this.signupform['controls'].confirmpassword.setErrors({ 'invalidpwd': true })
            } else {
                this.signupform['controls'].confirmpassword.setErrors(null)
            }
        })

    }


    /**
     * Get company typeahead name from the event
     * @param event 
     */
    getDropdown(event: any, type: string) {
        let searchText = '';
        if (type == '' || type == null) {
            searchText = '';
        } else {
            searchText = event.target.value;
        }
        this.loginService.getCompanyTypeAhead(searchText).subscribe((response: any) => {
            if (response && response['status'] == 'success') {
                this.companyName = response?.data
            } else {
                this.companyName = [];
            }
        });
    };

    /**
     * Select company name from dropdown
     * @param event 
     * @param type 
     */
    selectedItem(event: any, type: string) {
        const selectedCompany = event.option.value;
        this.signupform['controls'].companyname.setValue(selectedCompany);
    };

    /**
     * Function to handle user self signup
     */
    userSignUp() {
        const parameter = {
            firstname: this.signupform.getRawValue().firstName,
            lastname: this.signupform.getRawValue().lastName,
            loginemail: this.user_emailid ? this.user_emailid : this.signupform.getRawValue().loginemail,
            adminloginemail: this.admin_emailid ? this.admin_emailid : '',
            pwd: this.signupform.getRawValue().password,
            designation: this.signupform.getRawValue().designation,
            company: this.signupform.getRawValue().companyname,
        };

        this.loginService.selfSignup(parameter).subscribe((response: any) => {
            if (response && response['status'] == 'success' && response['message'] == 'User Created Successfully') {
                this.successMessage = "Registration successful! Redirecting to login…";
                setTimeout(() => {
                    this.successMessage = '';
                    this.router.navigate(['/login']);
                }, 3000);
            } else if (response && response['status'] == 'failure') {
                if (response['message'] == 'Admin Team Invite Not Present') {
                    this.errorMessage = "You are not invited by any team admin. Please reach out to admin";
                } else if (response['message'] == 'Maximum Team Invite Limit Reached') {
                    this.errorMessage = "Maximum Team Invite Limit Reached";
                } else if (response['message'] == 'User Already Exist') {
                    this.errorMessage = "You are already registered. Please login.";
                    setTimeout(() => {
                        this.successMessage = '';
                        this.router.navigate(['/login']);
                    }, 3000);
                } else {
                    this.errorMessage = "Something went wrong. Please try again later.";
                }
                setTimeout(() => {
                    this.errorMessage = '';
                }, 5000);
            }
        });
    };

    /**
     * Function to check if the password and confirm password match
     * @returns 
     */
    reconfirmpwd() {
        if (this.signupform.value.password == this.signupform.value.confirmpwd) {
            return this.signupform['controls'].confirmpwd.setErrors(null)
        } else {
            return this.signupform['controls'].confirmpwd.setErrors({ 'invalidpwd': true })
        }
    }

    showpassworderror() {
        this.showpassword = true
    }

    focusOut() {
        this.showpassword = false
    }


    redirect() {
        const downloadLink = document.createElement("a");
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.setAttribute("href", 'https://webbtree.freshdesk.com/support/tickets/new');
        downloadLink.setAttribute("target", "_blank");
        downloadLink.click();
    };

}